document.addEventListener('click',function(event){
  const menuButton=event.target.closest('[data-ds-menu]');
  if(menuButton){const nav=document.querySelector('.ds-nav');if(nav){const open=nav.classList.toggle('is-open');menuButton.setAttribute('aria-expanded',String(open));}return;}
  const thumb=event.target.closest('[data-ds-thumb]');
  if(thumb){const main=document.querySelector('[data-ds-main-image]');if(main){main.src=thumb.dataset.src;document.querySelectorAll('[data-ds-thumb]').forEach(el=>el.setAttribute('aria-current','false'));thumb.setAttribute('aria-current','true');}return;}
});
document.addEventListener('change',function(event){
  if(event.target.matches('[data-ds-sort]'))event.target.form?.submit();
});
function dsUpdateVariant(){
  const root=document.querySelector('[data-ds-product]');if(!root)return;
  const data=JSON.parse(root.querySelector('[data-ds-variants]')?.textContent||'[]');
  const color=root.querySelector('input[name="ds-color"]:checked')?.value;
  const kit=root.querySelector('input[name="ds-kit"]:checked')?.value;
  const variant=data.find(v=>v.options&&v.options[0]===color&&v.options[1]===kit);
  const select=root.querySelector('select[name="id"]');
  if(variant&&select){select.value=String(variant.id);select.dispatchEvent(new Event('change',{bubbles:true}));}
  const activeCard=root.querySelector('input[name="ds-kit"]:checked')?.closest('.ds-kit');
  const price=activeCard?.querySelector('[data-ds-current-price]');if(price&&variant)price.textContent=(variant.price/100).toLocaleString(undefined,{style:'currency',currency:'USD'});
}
document.addEventListener('change',function(event){if(event.target.matches('input[name="ds-color"],input[name="ds-kit"]'))dsUpdateVariant();});
document.addEventListener('DOMContentLoaded',dsUpdateVariant);
